<!-- PROCESO NORMAL -->
@if (!isVisibleCapture) {
    <tec-pwcs-layout
        [ngClass]="{ dark: designService.isDarkMode(), 'hide-subtitle': !(pageWarning.show || handsetLandscape) }"
        [title]="pageWarning.type === PAGE_WARNING.HELP ? (helpTitle | translate) : ''"
        [subtitle]="!handsetLandscape ? subtitle : ''"
    >
        <tec-progress
            [value]="progressService.getValue(docsConf)"
            role="progressbar"
            [ariaLabel]="'DOCUMENTS.ACCESSIBILITY.PROGRESS_GENERAL' | translate"
        />

        <ng-container content>
            <!-- MAIN -->
            <div
                class="content__identity"
                [ngStyle]="{
                    display: operation?.config.tutorial || pageWarning.show || handsetLandscape ? 'none' : 'contents'
                }"
            >
                @if (loading.show) {
                    <tec-spinner
                        [show]="loading.show"
                        [opaque]="true"
                        [text]="loading.text"
                        [img]="designService.getCustomSpinnerUrl() || undefined"
                    />
                }

                @if (!pageWarning.show) {
                    <!-- FORM 1 ARCHIVO -->
                    @if (totalDocCount === 1) {
                        <tec-tile
                            type="default"
                            icon="icon-file"
                            class="one-doc"
                            style="width: 100%"
                            [subtitle]="getCompleteDocumentText(operation.config.docs[0])"
                        >
                            <h5>
                                {{
                                    getDisplayDocumentTitle(operation.config.docs[0]) ||
                                        'DOCUMENTS.TYPES.' + operation.config.docs[0]?.type | translate
                                }}
                            </h5>

                            @if (hasDocumentInstructions(operation.config.docs[0])) {
                                <ng-container actions>
                                    <tec-link
                                        (click)="openInstructionsModal(operation.config.docs[0])"
                                        [ariaLabel]="
                                            'DOCUMENTS.ACCESSIBILITY.INSTRUCTIONS_FOR'
                                                | translate
                                                    : {
                                                          documentType:
                                                              getDisplayDocumentTitle(operation.config.docs[0])
                                                      }
                                        "
                                        [label]="'DOCUMENTS.INSTRUCTIONS' | translate"
                                    />
                                </ng-container>
                            }

                            <!-- Mostrar progreso si puede tener múltiples archivos -->
                            @if (
                                getMinCount(operation.config.docs[0]) > 1 &&
                                getMaxCount(operation.config.docs[0]) > 1 &&
                                getMinCount(operation.config.docs[0]) === getMaxCount(operation.config.docs[0])
                            ) {
                                <tec-progress
                                    style="width: 100%"
                                    [value]="getProgressValue(operation.config.docs[0])"
                                    [label]="getProgressLabel(operation.config.docs[0])"
                                    [color]="'default'"
                                    [size]="'default'"
                                    role="progressbar"
                                    [ariaLabel]="
                                        'DOCUMENTS.ACCESSIBILITY.PROGRESS_GROUP'
                                            | translate: { label: getProgressLabel(operation.config.docs[0]) }
                                    "
                                />
                            }

                            @if (getUploadedCount(operation.config.docs[0]) === 0) {
                                <!-- Mostrar alert de tamaño de archivos si es necesario -->
                                @if (fileSizeAlerts[operation.config.docs[0]?.uuid]?.show) {
                                    <tec-alert
                                        style="width: 100%"
                                        [msg]="fileSizeAlerts[operation.config.docs[0]?.uuid]?.message"
                                        [status]="'warning'"
                                        (closeAlert)="closeSizeAlert(operation.config.docs[0]?.uuid)"
                                        (buttonClicked)="buttonClicked()"
                                    />
                                }

                                <!-- Mostrar alert de extensión de archivo si es necesario -->
                                @if (fileExtensionAlerts[operation.config.docs[0]?.uuid]?.show) {
                                    <tec-alert
                                        style="width: 100%"
                                        [msg]="fileExtensionAlerts[operation.config.docs[0]?.uuid]?.message"
                                        [status]="'warning'"
                                        (closeAlert)="closeExtensionAlert(operation.config.docs[0]?.uuid)"
                                        (buttonClicked)="buttonClicked()"
                                    />
                                }

                                <!-- Mostrar alert de demasiados archivos seleccionados si es necesario -->
                                @if (tooManyFilesAlerts[operation.config.docs[0]?.uuid]?.show) {
                                    <tec-alert
                                        style="width: 100%"
                                        [msg]="tooManyFilesAlerts[operation.config.docs[0]?.uuid]?.message"
                                        [status]="'warning'"
                                        (closeAlert)="closeAlert(operation.config.docs[0]?.uuid)"
                                        (buttonClicked)="buttonClicked()"
                                    />
                                }

                                <!-- Mostrar alert de archivos no añadidos si es necesario -->
                                @if (notAllFilesAddedAlerts[operation.config.docs[0]?.uuid]?.show) {
                                    <tec-alert
                                        style="width: 100%"
                                        [msg]="notAllFilesAddedAlerts[operation.config.docs[0]?.uuid]?.message"
                                        [status]="'warning'"
                                        (closeAlert)="closeAlert(operation.config.docs[0]?.uuid)"
                                        (buttonClicked)="buttonClicked()"
                                    />
                                }
                            }

                            <!-- Mostrar archivos existentes -->
                            @if (getUploadedCount(operation.config.docs[0]) > 0) {
                                <tec-item-group style="width: 100%">
                                    @for (
                                        file of selectedFiles[operation.config.docs[0]?.uuid];
                                        track file;
                                        let i = $index
                                    ) {
                                        @if (file) {
                                            <tec-item
                                                [tagImage]="{
                                                    icon: file?.name?.toLowerCase().endsWith('.pdf')
                                                        ? 'icon-pdf'
                                                        : 'icon-image'
                                                }"
                                                [detailAction]="formatFileSize(file?.size)"
                                            >
                                                @if (
                                                    documentServerErrors[operation.config.docs[0]?.uuid] &&
                                                    documentStatuses[operation.config.docs[0]?.uuid] === 'KO'
                                                ) {
                                                    <tec-tag
                                                        [status]="'error'"
                                                        [color]="'red'"
                                                        [label]="'DOCUMENTS.ERROR.GENERAL' | translate"
                                                    />
                                                }

                                                <tec-list-detail>
                                                    <span [title]="file?.name">{{ truncateFileName(file?.name) }}</span>
                                                </tec-list-detail>
                                                <tec-button-icon
                                                    icon="icon-trash"
                                                    (click)="removeFileByUuid(operation.config.docs[0]?.uuid, i)"
                                                    [ariaLabel]="
                                                        'DOCUMENTS.ACCESSIBILITY.DELETE_FILE'
                                                            | translate: { fileName: file?.name }
                                                    "
                                                />
                                            </tec-item>
                                        }
                                    }
                                </tec-item-group>
                            }

                            <!-- Mostrar upload si no hay archivos -->
                            @if (
                                getUploadedCount(operation.config.docs[0]) === 0 &&
                                canAddMoreFiles(operation.config.docs[0]) &&
                                getNextAvailableIndex(operation.config.docs[0]) >= 0
                            ) {
                                @if (operation.config.docs[0].type !== 'IRPF' || (operation.config.docs[0].type === 'IRPF' && !formCVE.value)) {
                                    <app-document-upload
                                        [method]="operation.config.docs[0].method || 'both'"
                                        [multiple]="getMaxCount(operation.config.docs[0]) > 1"
                                        [acceptedFileTypes]="getAllowedExtensionsForDisplay()"
                                        [control]="
                                            getDocControl(
                                                operation.config.docs[0]?.uuid,
                                                getNextAvailableIndex(operation.config.docs[0])
                                            )
                                        "
                                        [ariaLabel]="
                                            'DOCUMENTS.ACCESSIBILITY.UPLOAD_LABEL'
                                                | translate
                                                    : {
                                                          documentType:
                                                              getDisplayDocumentTitle(operation.config.docs[0])
                                                      }
                                        "
                                        (filesSelected)="
                                            handleFileInput(
                                                $event,
                                                operation.config.docs[0]?.uuid,
                                                getNextAvailableIndex(operation.config.docs[0])
                                            )
                                        "
                                        (cameraClicked)="triggerTakePhoto(operation.config.docs[0])"
                                    />
                                }
                                @if (operation.config.docs[0].type === 'IRPF'){
                                    <ng-container [ngTemplateOutlet]="CveIRPF"></ng-container>
                                }
                            }

                            @if (getUploadedCount(operation.config.docs[0]) > 0) {
                                <!-- Mostrar alert de tamaño de archivos si es necesario -->
                                @if (fileSizeAlerts[operation.config.docs[0]?.uuid]?.show) {
                                    <tec-alert
                                        style="width: 100%"
                                        [msg]="fileSizeAlerts[operation.config.docs[0]?.uuid]?.message"
                                        [status]="'warning'"
                                        (closeAlert)="closeSizeAlert(operation.config.docs[0]?.uuid)"
                                        (buttonClicked)="buttonClicked()"
                                    />
                                }

                                <!-- Mostrar alert de extensión de archivo si es necesario -->
                                @if (fileExtensionAlerts[operation.config.docs[0]?.uuid]?.show) {
                                    <tec-alert
                                        style="width: 100%"
                                        [msg]="fileExtensionAlerts[operation.config.docs[0]?.uuid]?.message"
                                        [status]="'warning'"
                                        (closeAlert)="closeExtensionAlert(operation.config.docs[0]?.uuid)"
                                        (buttonClicked)="buttonClicked()"
                                    />
                                }

                                <!-- Mostrar alert de demasiados archivos seleccionados si es necesario -->
                                @if (tooManyFilesAlerts[operation.config.docs[0]?.uuid]?.show) {
                                    <tec-alert
                                        style="width: 100%"
                                        [msg]="tooManyFilesAlerts[operation.config.docs[0]?.uuid]?.message"
                                        [status]="'warning'"
                                        (closeAlert)="closeAlert(operation.config.docs[0]?.uuid)"
                                        (buttonClicked)="buttonClicked()"
                                    />
                                }

                                <!-- Mostrar alert de archivos no añadidos si es necesario -->
                                @if (notAllFilesAddedAlerts[operation.config.docs[0]?.uuid]?.show) {
                                    <tec-alert
                                        style="width: 100%"
                                        [msg]="notAllFilesAddedAlerts[operation.config.docs[0]?.uuid]?.message"
                                        [status]="'warning'"
                                        (closeAlert)="closeAlert(operation.config.docs[0]?.uuid)"
                                        (buttonClicked)="buttonClicked()"
                                    />
                                }
                            }

                            <ng-container buttons>
                                @if (
                                    getUploadedCount(operation.config.docs[0]) > 0 &&
                                    canAddMoreFiles(operation.config.docs[0])
                                ) {
                                    <app-document-actions
                                        [method]="operation.config.docs[0].method || 'both'"
                                        [hasPdfFiles]="hasPdfFiles(operation.config.docs[0])"
                                        (exploreClicked)="triggerFileUpload(operation.config.docs[0])"
                                        (takePhotoClicked)="triggerTakePhoto(operation.config.docs[0])"
                                    />
                                }
                            </ng-container>
                        </tec-tile>
                    }
                    <!-- FORM MÁS DE 1 ARCHIVO -->
                    @if (totalDocCount > 1) {
                        <tec-item-group style="width: 100%">
                            @for (doc of operation.config.docs; track doc; let i = $index) {
                                <tec-item
                                    [title]="getDisplayDocumentTitle(doc)"
                                    [collapse]="true"
                                    [expanded]="expandedDocUuid === doc.uuid"
                                    [tagIcon]="{
                                        icon: documentStatuses[doc.uuid] === 'OK' ? 'icon-check' : 'icon-alert',
                                        status: !documentStatuses[doc.uuid]
                                            ? 'empty'
                                            : documentStatuses[doc.uuid] === 'OK'
                                              ? 'success'
                                              : 'default',
                                        size: 'sm'
                                    }"
                                    [attr.aria-expanded]="expandedDocUuid === doc.uuid"
                                    (clickExpandedEvent)="toggleDocumentExpansion(doc.uuid, $event)"
                                >
                                    @if (
                                        doc?.required && documentStatuses[doc.uuid] !== 'OK' && !areAllDocsRequired()
                                    ) {
                                        <tec-tag
                                            status="warning"
                                            [ariaLabel]="'DOCUMENTS.ACCESSIBILITY.REQUIRED_DOCUMENT' | translate"
                                            >{{ 'DOCUMENTS.REQUIRED' | translate }}</tec-tag
                                        >
                                    }
                                    @if (getCompleteDocumentText(doc) || hasDocumentInstructions(doc)) {
                                        <div>
                                            @if (getCompleteDocumentText(doc)) {
                                                <span [innerHTML]="getCompleteDocumentText(doc)"></span>
                                            }
                                            @if (hasDocumentInstructions(doc)) {
                                                <tec-link
                                                    (click)="openInstructionsModal(doc)"
                                                    [ariaLabel]="
                                                        'DOCUMENTS.ACCESSIBILITY.INSTRUCTIONS_FOR'
                                                            | translate
                                                                : {
                                                                      documentType: getDisplayDocumentTitle(doc)
                                                                  }
                                                    "
                                                    [label]="'DOCUMENTS.INSTRUCTIONS' | translate"
                                                />
                                            }
                                        </div>
                                    }

                                    <!-- Mostrar progreso de archivos subidos cuando min y max son iguales y mayores a 1 -->
                                    @if (
                                        getMinCount(doc) > 1 &&
                                        getMaxCount(doc) > 1 &&
                                        getMinCount(doc) === getMaxCount(doc)
                                    ) {
                                        <tec-progress
                                            style="width: 100%"
                                            [value]="getProgressValue(doc)"
                                            [label]="getProgressLabel(doc)"
                                            [color]="'default'"
                                            [size]="'default'"
                                            role="progressbar"
                                            [ariaLabel]="
                                                'DOCUMENTS.ACCESSIBILITY.PROGRESS_GROUP'
                                                    | translate: { label: getProgressLabel(doc) }
                                            "
                                        />
                                    }

                                    @if (getUploadedCount(doc) === 0) {
                                        <!-- Mostrar alert de tamaño de archivos si es necesario (cuando no hay archivos) -->
                                        @if (fileSizeAlerts[doc.uuid]?.show) {
                                            <tec-alert
                                                style="width: 100%"
                                                [msg]="fileSizeAlerts[doc.uuid]?.message"
                                                [status]="'warning'"
                                                (closeAlert)="closeSizeAlert(doc.uuid)"
                                                (buttonClicked)="buttonClicked()"
                                            />
                                        }

                                        <!-- Mostrar alert de extensión de archivo si es necesario (cuando no hay archivos) -->
                                        @if (fileExtensionAlerts[doc.uuid]?.show) {
                                            <tec-alert
                                                style="width: 100%"
                                                [msg]="fileExtensionAlerts[doc.uuid]?.message"
                                                [status]="'warning'"
                                                (closeAlert)="closeExtensionAlert(doc.uuid)"
                                                (buttonClicked)="buttonClicked()"
                                            />
                                        }

                                        <!-- Mostrar alert de demasiados archivos seleccionados si es necesario -->
                                        @if (tooManyFilesAlerts[doc.uuid]?.show) {
                                            <tec-alert
                                                style="width: 100%"
                                                [msg]="tooManyFilesAlerts[doc.uuid]?.message"
                                                [status]="'warning'"
                                                (closeAlert)="closeAlert(doc.uuid)"
                                                (buttonClicked)="buttonClicked()"
                                            />
                                        }

                                        <!-- Mostrar alert de archivos no añadidos si es necesario -->
                                        @if (notAllFilesAddedAlerts[doc.uuid]?.show) {
                                            <tec-alert
                                                style="width: 100%"
                                                [msg]="notAllFilesAddedAlerts[doc.uuid]?.message"
                                                [status]="'warning'"
                                                (closeAlert)="closeAlert(doc.uuid)"
                                                (buttonClicked)="buttonClicked()"
                                            />
                                        }
                                    }

                                    <!-- Mostrar archivos existentes para este documento -->
                                    @if (getUploadedCount(doc) > 0) {
                                        <tec-item-group style="width: 100%">
                                            @for (file of selectedFiles[doc.uuid]; track file; let i = $index) {
                                                @if (file) {
                                                    <tec-item
                                                        [tagImage]="{
                                                            icon: file?.name?.toLowerCase().endsWith('.pdf')
                                                                ? 'icon-pdf'
                                                                : 'icon-image'
                                                        }"
                                                        [detailAction]="formatFileSize(file?.size)"
                                                    >
                                                        @if (
                                                            documentServerErrors[doc.uuid] &&
                                                            documentStatuses[doc.uuid] === 'KO'
                                                        ) {
                                                            <tec-tag
                                                                [status]="'error'"
                                                                [color]="'red'"
                                                                [label]="'DOCUMENTS.ERROR.GENERAL' | translate"
                                                            />
                                                        }

                                                        <tec-list-detail>
                                                            <span [title]="file?.name">{{
                                                                truncateFileName(file?.name)
                                                            }}</span>
                                                        </tec-list-detail>
                                                        <tec-button-icon
                                                            icon="icon-trash"
                                                            (click)="removeFileByUuid(doc.uuid, i)"
                                                            [ariaLabel]="
                                                                'DOCUMENTS.ACCESSIBILITY.DELETE_FILE'
                                                                    | translate: { fileName: file?.name }
                                                            "
                                                        />
                                                    </tec-item>
                                                }
                                            }
                                        </tec-item-group>
                                    }

                                    <!-- Mostrar upload si no hay archivos -->
                                    @if (
                                        getUploadedCount(doc) === 0 &&
                                        canAddMoreFiles(doc) &&
                                        getNextAvailableIndex(doc) >= 0
                                    ) {
                                        @if (doc.type !== 'IRPF' || (doc.type === 'IRPF' && !formCVE.value)) {
                                            <app-document-upload
                                                style="width: 100%"
                                                [method]="doc.method || 'both'"
                                                [multiple]="getMaxCount(doc) > 1"
                                                [acceptedFileTypes]="getAllowedExtensionsForDisplay()"
                                                [control]="getDocControl(doc.uuid, getNextAvailableIndex(doc))"
                                                [ariaLabel]="
                                                    'DOCUMENTS.ACCESSIBILITY.UPLOAD_LABEL'
                                                        | translate
                                                            : {
                                                                documentType: getDisplayDocumentTitle(doc)
                                                            }
                                                "
                                                (filesSelected)="
                                                    handleFileInput($event, doc.uuid, getNextAvailableIndex(doc))
                                                "
                                                (cameraClicked)="triggerTakePhoto(doc)"
                                            />
                                        }
                                        @if (doc.type === 'IRPF'){
                                            <div class="tile__body" style="width: 100%;">
                                                <ng-container [ngTemplateOutlet]="CveIRPF"></ng-container>
                                            </div>
                                        }
                                    }

                                    @if (getUploadedCount(doc) > 0) {
                                        <!-- Mostrar alert de tamaño de archivos si es necesario (cuando ya hay archivos) -->
                                        @if (fileSizeAlerts[doc.uuid]?.show) {
                                            <tec-alert
                                                style="width: 100%"
                                                [msg]="fileSizeAlerts[doc.uuid]?.message"
                                                [status]="'warning'"
                                                (closeAlert)="closeSizeAlert(doc.uuid)"
                                                (buttonClicked)="buttonClicked()"
                                            />
                                        }

                                        <!-- Mostrar alert de extensión de archivo si es necesario (cuando ya hay archivos) -->
                                        @if (fileExtensionAlerts[doc.uuid]?.show) {
                                            <tec-alert
                                                style="width: 100%"
                                                [msg]="fileExtensionAlerts[doc.uuid]?.message"
                                                [status]="'warning'"
                                                (closeAlert)="closeExtensionAlert(doc.uuid)"
                                                (buttonClicked)="buttonClicked()"
                                            />
                                        }

                                        <!-- Mostrar alert de demasiados archivos seleccionados si es necesario -->
                                        @if (tooManyFilesAlerts[doc.uuid]?.show) {
                                            <tec-alert
                                                style="width: 100%"
                                                [msg]="tooManyFilesAlerts[doc.uuid]?.message"
                                                [status]="'warning'"
                                                (closeAlert)="closeAlert(doc.uuid)"
                                                (buttonClicked)="buttonClicked()"
                                            />
                                        }

                                        <!-- Mostrar alert de archivos no añadidos si es necesario -->
                                        @if (notAllFilesAddedAlerts[doc.uuid]?.show) {
                                            <tec-alert
                                                style="width: 100%"
                                                [msg]="notAllFilesAddedAlerts[doc.uuid]?.message"
                                                [status]="'warning'"
                                                (closeAlert)="closeAlert(doc.uuid)"
                                                (buttonClicked)="buttonClicked()"
                                            />
                                        }
                                    }

                                    <!-- Mostrar botón "Siguiente" para navegar al siguiente documento -->
                                    @if (
                                        getUploadedCount(doc) === getMaxCount(doc) &&
                                        i < operation.config.docs.length - 1
                                    ) {
                                        <div>
                                            <tec-button
                                                size="sm"
                                                [label]="'GENERAL.BUTTON.NEXT' | translate"
                                                (clickEvent)="goToNextDocument(i)"
                                            />
                                        </div>
                                    }

                                    <!-- Botón para agregar más archivos cuando ya hay archivos -->
                                    @if (getUploadedCount(doc) > 0 && canAddMoreFiles(doc)) {
                                        <app-document-actions
                                            [method]="doc.method || 'both'"
                                            [hasPdfFiles]="hasPdfFiles(doc)"
                                            (exploreClicked)="triggerFileUpload(doc)"
                                            (takePhotoClicked)="triggerTakePhoto(doc)"
                                        />
                                    }
                                </tec-item>
                            }
                        </tec-item-group>
                    }
                }
            </div>

            <!-- TUTORIAL -->
            @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
                @if (hasAttorneyPowersLikeDocs()) {
                <div class="tutorial-image">
                    <pwcs-inline-svg
                        [src]="'assets/images/connection-escrituras-tutorial' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                        idSuffix="docs-attorney-powers-tutorial"
                    />
                </div>
                } @else {
                <div class="tutorial-image">
                    <pwcs-inline-svg
                        [src]="'assets/images/docs-tutorial' + (designService.isDarkMode() ? '-dark' : '') + '.svg'"
                        idSuffix="docs-tutorial"
                    />
                </div>
                <tec-link (click)="openDocumentHelp()">
                    {{ 'DOCUMENTS.TUTORIAL.WHAT_DOCUMENTS_NEEDED' | translate }}
                </tec-link>
                }
            }

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    <div class="layout--50-50">
                        <tec-tile type="default" styling="default" [badge]="{ label: '1' }">
                            <h5>{{ 'DOCUMENTS.HELP.TITLE_1' | translate }}</h5>
                            <span class="f16" [innerHTML]="'DOCUMENTS.HELP.DESCRIPTION_DOC' | translate"></span>
                            <ul>
                                @for (doc of operation.config.docs; track doc) {
                                    <li>
                                        <div class="doc-help-item">
                                            <span>{{ getDisplayDocumentTitle(doc) }}</span>
                                            @if (doc?.required && operation.config.docs.length > 1) {
                                                <span class="required-indicator"
                                                    >&nbsp;{{ 'DOCUMENTS.REQUIRED_PARENTHESES' | translate }}</span
                                                >
                                            }
                                            @if (hasDocumentInstructions(doc)) {
                                                &nbsp;
                                                <tec-icon
                                                    name="icon-info"
                                                    style="cursor: pointer"
                                                    [size]="'xs'"
                                                    (click)="openInstructionsModal(doc)"
                                                />
                                            }
                                        </div>
                                    </li>
                                }
                            </ul>
                        </tec-tile>
                        <tec-tile type="default" styling="default" [badge]="{ label: '2' }">
                            <h5>{{ 'DOCUMENTS.HELP.TITLE_2' | translate }}</h5>
                            <div class="grid grid-e2-sm grid-no-responsive">
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="
                                            'assets/images/doc-no-borroso' +
                                            (designService.isDarkMode() ? '-dark' : '') +
                                            '.svg'
                                        "
                                        idSuffix="docs-help-doc-no-borroso"
                                    />
                                    <span>{{ 'DOCUMENTS.HELP.TIP_1' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="
                                            'assets/images/doc-no-recortado' +
                                            (designService.isDarkMode() ? '-dark' : '') +
                                            '.svg'
                                        "
                                        idSuffix="docs-help-doc-no-recortado"
                                    />
                                    <span>{{ 'DOCUMENTS.HELP.TIP_2' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="
                                            'assets/images/doc-no-brillos' +
                                            (designService.isDarkMode() ? '-dark' : '') +
                                            '.svg'
                                        "
                                        idSuffix="docs-help-doc-no-brillos"
                                    />
                                    <span>{{ 'DOCUMENTS.HELP.TIP_3' | translate }}</span>
                                </div>
                                <div class="image-group">
                                    <pwcs-inline-svg
                                        [src]="
                                            'assets/images/doc-no-sombras' +
                                            (designService.isDarkMode() ? '-dark' : '') +
                                            '.svg'
                                        "
                                        idSuffix="docs-help-doc-no-sombras"
                                    />
                                    <span>{{ 'DOCUMENTS.HELP.TIP_4' | translate }}</span>
                                </div>
                            </div>
                        </tec-tile>
                    </div>
                }
                @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                    <tec-tile
                        type="status"
                        [title]="(pageWarning.titleKey || 'DOCUMENTS.ERROR.SERVER_ERROR.TITLE') | translate"
                        [subtitle]="(pageWarning.subtitleKey || 'DOCUMENTS.ERROR.SERVER_ERROR.DESCRIPTION') | translate"
                        icon="icon-alert"
                    />
                }
                @if (pageWarning.type === PAGE_WARNING.INACTIVITY_TIMEOUT) {
                    <tec-tile
                        type="status"
                        [title]="'DOCUMENTS.ERROR.INACTIVITY_TIMEOUT.TITLE' | translate"
                        [subtitle]="'DOCUMENTS.ERROR.INACTIVITY_TIMEOUT.DESCRIPTION' | translate"
                        icon="icon-alert"
                    />
                }
            }

            <!-- HANDSETLANDSCAPE -->
            @if (handsetLandscape && !pageWarning.show) {
                <app-handset-landscape-tile />
            }
        </ng-container>

        <!-- ACCIONES -->
        <ng-container actions>
            <!-- CONTINUAR -->
            @if (!operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
                <tec-button
                    [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                    [type]="'default'"
                    [size]="'lg'"
                    (clickEvent)="sendDocs()"
                />
            }

            <!-- TUTORIAL -->
            @if (operation?.config.tutorial && !pageWarning.show && !handsetLandscape) {
                <tec-button
                    [label]="'GENERAL.BUTTON.IM_READY' | translate"
                    [type]="'default'"
                    [size]="'lg'"
                    (clickEvent)="finishTutorial()"
                />
            }

            <!-- HELP -->
            @if (pageWarning.show) {
                @if (pageWarning.type === PAGE_WARNING.HELP) {
                    @if (isHelpAdditionalInfo) {
                        <tec-button
                            [label]="'GENERAL.BUTTON.CONTINUE' | translate"
                            [type]="'default'"
                            [size]="'lg'"
                            (clickEvent)="setPageWarning(null, false)"
                        />
                    }

                    @if (!isHelpAdditionalInfo) {
                        <!-- DESDE tec-nav-help -->
                        @if (isHelpByNavHelp) {
                            <tec-button
                                [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                                [type]="'secondary'"
                                [size]="'lg'"
                                (clickEvent)="changeDevice()"
                            />
                            <tec-button
                                [label]="'GENERAL.BUTTON.GO_BACK' | translate"
                                [type]="'default'"
                                [size]="'lg'"
                                (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.HELP)"
                            />
                        }

                        <!-- DESDE SEGUNDO INTENTO -->
                        @if (!isHelpByNavHelp) {
                            <tec-button
                                [label]="'GENERAL.BUTTON.RETRY' | translate"
                                [type]="'secondary'"
                                [size]="'lg'"
                                (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.HELP)"
                            />
                            <tec-button
                                [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                                [type]="'default'"
                                [size]="'lg'"
                                (clickEvent)="changeDevice()"
                            />
                        }
                    }
                }
                @if (pageWarning.type === PAGE_WARNING.SERVER_ERROR) {
                    <tec-button
                        [label]="'GENERAL.BUTTON.CHANGE_DEVICE' | translate"
                        [type]="'secondary'"
                        [size]="'lg'"
                        (clickEvent)="changeDevice()"
                    />
                    <tec-button
                        [label]="'GENERAL.BUTTON.RETRY' | translate"
                        [type]="'default'"
                        [size]="'lg'"
                        (clickEvent)="retryAllProcess('Button ' + PAGE_WARNING.SERVER_ERROR)"
                    />
                }
            }
        </ng-container>

        <!-- NAV HELP -->
        @if (!operation?.config?.iframe && !pageWarning.show && !handsetLandscape) {
            <tec-nav-help
                [elements]="operation?.config?.tutorial ? navsHelpTutorial : navsHelp"
                (clickEvent)="navHelpChange($event)"
                [ariaLabel]="'DOCUMENTS.ACCESSIBILITY.NAV_HELP_DOCUMENTS' | translate"
            />
        }

        <!-- WATERMARK -->
        @if ((designService.configDesign$ | async)?.showWatermark && !operation?.config?.iframe) {
            <tec-watermark type="default" aria-hidden="true" />
        }
    </tec-pwcs-layout>
}

<ng-template #CveIRPF>
    @if (!formCVE.value) {
        <tec-divider [label]="'DOCUMENTS.CEA.DISCLAMER' | translate"></tec-divider>
    }
    <tec-form-group [label]="'DOCUMENTS.CEA.FORM_TITLE' | translate"
        [errorMsg]="reactiveFormService.hasMsgError(formCVE)">
        <tec-input
            [formControl]="formCVE"
            [placeholder]="'DOCUMENTS.CEA.FORM_PLACEHOLDER' | translate"
            [hasError]="reactiveFormService.hasError(formCVE)"
        ></tec-input>
        <tec-link (click)="isVisibleCveIrpfHelp = true">{{ 'GENERAL.BUTTON.GET_HELP' | translate }}</tec-link>
    </tec-form-group>
</ng-template>

@if (isVisibleCapture) {
    <app-docs-take-photo
        [doc]="photoCaptureConfig?.doc"
        [operation]="operation"
        [fileExtension]="photoCaptureConfig?.fileExtension"
        [faceSlot]="photoCaptureConfig?.faceSlot"
        (photoTaken)="onPhotoTaken($event)"
    />
}

<app-modal-scan-qr
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleScan"
    [url]="auth.getQRUrl()"
/>

<app-modal-change-device
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleChangeDevice"
    (isVisibleChange)="restartInactivityTimerOnClose()"
    [url]="auth.getQRUrl()"
/>

<app-modal-instructions
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisibleInstructions"
    (isVisibleChange)="restartInactivityTimerOnClose()"
    [doc]="selectedDoc"
/>

<app-modal-pending-documents
    [ngClass]="{ dark: designService.isDarkMode() }"
    [(isVisible)]="isVisiblePendingDocuments"
/>

<app-modal-irpf-cve-help
    [ngClass]="{'dark': designService.isDarkMode()}"
    [(isVisible)]="isVisibleCveIrpfHelp"
/>
